var urlPath = getUrlPathname();
const productVersion = "2.0";
const formattedVersion = "v2";

function getUrlPathname() {
    let pagePath = window.location.pathname;
    let pathFormat = ((pagePath.charAt(pagePath.length - 1) == "/") ? pagePath.slice(0, -1) : pagePath);
    return pathFormat.substring(0, pathFormat.lastIndexOf("/"));
}

function showOverlay(category) {
    document.querySelector(".overlay[category='" + category + "']").classList.add("overlayVisible");
}

function hideOverlay(element) {
    var overlay = element.closest(".overlay");
    overlay.classList.remove("overlayVisible");
}

// Show action results / status message
function showStatusMessage(title, message) {
    messageOverlay.querySelector(".overlayTitle").innerHTML = title;
    messageOverlay.querySelector(".overlayText").innerHTML = message;
    showOverlay("message");
    // Set focus on button
    if (document.querySelector("#messageOverlayButton")) {
        document.querySelector("#messageOverlayButton").focus();
    }
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (null);
}

function checkForDebugMessages(response) {
    try {
        if (response.debug != undefined) {
            for (var field in response.debug) {
                console.log(response.debug[field]);
            }
        }
    } catch (e) {
        console.log("Could not process debug messages.");
    }
}

function serverIsDownMessage() {
    // Run when the API server appears to be down or is returning data properly.
    console.error("API server down?");

    const main = document.querySelector("#main");
    main.classList.remove("mainHidden");
    main.classList.add("server-outage");
    main.innerHTML = ""; // Clear existing content

    const img = document.createElement("img");
    img.src = urlPath + "/images/datacity.svg";
    img.alt = "";
    main.appendChild(img);

    const msg = document.createElement("p");
    msg.innerHTML = "We're experiencing a temporary problem. Try again in a few minutes.";
    main.appendChild(msg);

    const retryBtn = document.createElement("button");
    retryBtn.innerHTML = "Retry";
    retryBtn.classList.add("mainButton");
    retryBtn.addEventListener("click", function() {
        window.location.reload();
    });
    main.appendChild(retryBtn);

    // Destroy any spinners if the page was still loading
    const spinner = document.querySelector("#spinnerHolder");
    if (spinner)
        spinner.remove();
}
